import { render, staticRenderFns } from "./AtypeList.vue?vue&type=template&id=0a47881f&scoped=true&"
import script from "./AtypeList.vue?vue&type=script&lang=js&"
export * from "./AtypeList.vue?vue&type=script&lang=js&"
import style0 from "./AtypeList.vue?vue&type=style&index=0&id=0a47881f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a47881f",
  null
  
)

export default component.exports